<template>
  <div class="modal fade" id="calibrationFormModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ isEdit ? 'Edit Calibration' : 'New Calibration' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="save">
            <div class="row mb-2">
              <div class="col">
                <label class="form-label">Name</label>
                <input v-model="form.name" type="text" class="form-control" required>
              </div>
              <div class="col">
                <label class="form-label">Site</label>
                <input v-model="form.site" type="text" class="form-control" required>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <label class="form-label">Year (month/year)</label>
                <input v-model="form.year" type="month" class="form-control" required>
              </div>
              <div class="col">
                <label class="form-label">Signal</label>
                <input v-model="form.signalWavelength" type="text" class="form-control" required>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <label class="form-label">Normalization</label>
                <input v-model="form.normWavelength" type="text" class="form-control" required>
              </div>
              <div class="col">
                <label class="form-label">Range</label>
                <div class="input-group">
                  <input v-model="form.rangeMin" type="number" step="any" class="form-control" placeholder="min" required>
                  <span class="input-group-text">–</span>
                  <input v-model="form.rangeMax" type="number" step="any" class="form-control" placeholder="max" required>
                  <select v-model="form.rangeUnit" class="form-select" style="max-width: 100px;">
                    <option>a.u.</option>
                    <option>mg/L</option>
                    <option>μg/L</option>
                    <option>ppm</option>
                    <option>units</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <label class="form-label">N</label>
                <input v-model="form.N" type="number" step="any" class="form-control" required>
              </div>
              <div class="col">
                <label class="form-label">R²</label>
                <input v-model="form.r2" type="number" step="0.001" min="0" max="1" class="form-control" required>
              </div>
              <div class="col">
                <label class="form-label">Sigma</label>
                <input v-model="form.sigma" type="number" step="any" class="form-control" required>
              </div>
              <div class="col">
                <label class="form-label">Bias</label>
                <input v-model="form.bias" type="number" step="any" class="form-control" required>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <label class="form-label">Equation: y = ax³ + bx² + cx + d</label>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-3">
                <label class="form-label">a</label>
                <input v-model="form.coeffA" type="number" step="any" class="form-control" placeholder="a">
              </div>
              <div class="col-3">
                <label class="form-label">b</label>
                <input v-model="form.coeffB" type="number" step="any" class="form-control" placeholder="b">
              </div>
              <div class="col-3">
                <label class="form-label">c</label>
                <input v-model="form.coeffC" type="number" step="any" class="form-control" placeholder="c">
              </div>
              <div class="col-3">
                <label class="form-label">d</label>
                <input v-model="form.coeffD" type="number" step="any" class="form-control" placeholder="d">
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <label class="form-label">OWT</label>
                <input v-model="form.OWT" type="number" step="any" class="form-control" required>
              </div>
              <div class="col">
                <label class="form-label">LiDAR Serial Number</label>
                <input v-model="form.LSN" type="text" class="form-control" required>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <label class="form-label">Comments</label>
                <input v-model="form.comments" type="text" class="form-control" required>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" @click="save">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
  name: 'CalibrationFormModal',
  props: {
    calibration: { type: Object, default: null }
  },
  data() {
    return {
      form: this.initForm(),
      modal: null
    };
  },
  computed: {
    isEdit() {
      return !!this.calibration;
    }
  },
  mounted() {
    this.modal = new Modal(document.getElementById('calibrationFormModal'));
    if (this.calibration) {
      this.form = { ...this.calibration };
    }
  },
  methods: {
    initForm() {
      return {
        id: null,
        name: '',
        site: '',
        year: '',
        signalWavelength: null,
        normWavelength: null,
        rangeMin: null,
        rangeMax: null,
        rangeUnit: 'mg/L',
        N: null,
        r2: null,
        sigma: null,
        bias: null,
        coeffA: 0,
        coeffB: 0,
        coeffC: 0,
        coeffD: 0
      };
    },
    open(calibration) {
      if (calibration) {
        this.form = { ...calibration };
      } else {
        // Новая запись: id не назначается, его выдаст БД на бэкенде.
        this.form = this.initForm();
      }
      this.modal.show();
    },
    close() {
      this.modal.hide();
    },
    save() {
      this.$emit('save', { ...this.form });
      this.close();
    }
  }
};
</script>